import React, { createContext, useContext, ReactNode } from 'react';
import { canStoreWrite, isStoreAdmin, isStoreViewer } from '../utils/storeRoles';

export type AuthUserContextValue = {
  role: string | null;
  isAdmin: boolean;
  isViewer: boolean;
  canWrite: boolean;
};

const AuthUserContext = createContext<AuthUserContextValue>({
  role: null,
  isAdmin: false,
  isViewer: false,
  canWrite: false,
});

export function AuthUserProvider({
  role,
  children,
}: {
  role: string | null;
  children: ReactNode;
}) {
  return (
    <AuthUserContext.Provider
      value={{
        role,
        isAdmin: isStoreAdmin(role),
        isViewer: isStoreViewer(role),
        canWrite: canStoreWrite(role),
      }}
    >
      {children}
    </AuthUserContext.Provider>
  );
}

export function useAuthUser(): AuthUserContextValue {
  return useContext(AuthUserContext);
}
